import "./ADUConstruction.module.css";
import Header from "@/reusable_sections/Header";
import Services from "./sections/Services";
import Portfolio from "./sections/Portfolio";
import Workflow from "./sections/Workflow";
import Faq from "./sections/Faq";
import Breakground, { GnciBooking } from "./sections/Breakground";
import Footer from "@/reusable_sections/Footer";

// Order (owner request Sept 17): booking form first, then completed ADUs, then what an ADU project can include.
// The former Hero section (./sections/Hero) is kept in the project but no longer shown.
export default function ADUConstructionPage() {
  return <div>
      <Header />
      <GnciBooking service="adu" />
      <Portfolio />
      <Services />
      <Workflow />
      <Faq />
      <Breakground />
      <Footer />
    </div>;
}